import React from "react"
import {
  planButtonStyle as buttonStyle,
  StatusBadge,
  SectionCard
} from "./PlanPrimitives"

export default function PlanWorkspaceHeader({
  plan,
  patientId,
  effectiveClinicId,
  formatDateTime,
  onOpenPatient,
  onOpenFinance,
  onPrint,
  onGoBack
}) {
  const patientName = plan?.patient
    ? `${plan.patient.firstName || ""} ${plan.patient.lastName || ""}`.trim()
    : patientId || "-"

  const clinicName =
    plan?.clinic?.name ||
    plan?.clinicName ||
    plan?.clinic?.title ||
    "-"

  const createdByName =
    plan?.createdBy?.name ||
    plan?.createdByName ||
    plan?.createdByUser?.name ||
    plan?.createdBy?.fullName ||
    plan?.user?.name ||
    "-"

  return (
    <div style={{ display: "grid", gap: 16 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 12,
          alignItems: "flex-start",
          flexWrap: "wrap"
        }}
      >
        <div>
          <div
            style={{
              display: "inline-flex",
              padding: "6px 10px",
              borderRadius: 999,
              background: "#eff6ff",
              border: "1px solid #bfdbfe",
              color: "#1d4ed8",
              fontSize: 10.5,
              fontWeight: 900,
              letterSpacing: 0.45,
              textTransform: "uppercase",
              marginBottom: 10
            }}
          >
            Workspace del plan
          </div>

          <div
            style={{
              fontSize: 30,
              fontWeight: 900,
              color: "#0f172a",
              letterSpacing: "-0.04em",
              lineHeight: 1.02
            }}
          >
            Detalle del plan
          </div>

          <div
            style={{
              color: "#64748b",
              marginTop: 6,
              fontSize: 13,
              lineHeight: 1.4
            }}
          >
            Operación clínica, seguimiento y entrega del plan al paciente.
          </div>
        </div>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button
            onClick={onPrint}
            disabled={!plan}
            style={{
              ...buttonStyle,
              background: "#eff6ff",
              border: "1px solid #bfdbfe",
              color: "#1d4ed8"
            }}
          >
            Imprimir
          </button>

          <button
            onClick={onOpenPatient}
            disabled={!patientId || !effectiveClinicId}
            style={buttonStyle}
          >
            Abrir paciente
          </button>

          <button
            onClick={() => onOpenFinance("RECEIVABLES")}
            disabled={!patientId || !effectiveClinicId}
            style={{
              ...buttonStyle,
              background: "#f8fafc"
            }}
          >
            Abrir finanzas
          </button>

          <button onClick={onGoBack} style={buttonStyle}>
            Volver
          </button>
        </div>
      </div>

      <SectionCard
        title={plan?.title || "Plan de tratamiento"}
        right={<StatusBadge status={plan?.status} />}
      >
        <div
          style={{
            display: "grid",
            gap: 10,
            color: "#475569",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))"
          }}
        >
          <InfoRow label="Paciente" value={patientName} />
          <InfoRow label="Clínica" value={clinicName} />
          <InfoRow label="Creado" value={formatDateTime(plan?.createdAt)} />
          <InfoRow label="Creado por" value={createdByName} />
          <InfoRow label="Notas" value={plan?.notes || "-"} full />
        </div>
      </SectionCard>
    </div>
  )
}

function InfoRow({ label, value, full = false }) {
  return (
    <div
      style={{
        border: "1px solid #e2e8f0",
        background: "#ffffff",
        borderRadius: 14,
        padding: 12,
        gridColumn: full ? "1 / -1" : "auto"
      }}
    >
      <div
        style={{
          fontSize: 11.5,
          color: "#64748b",
          textTransform: "uppercase",
          fontWeight: 900,
          letterSpacing: 0.35,
          marginBottom: 6
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: 14,
          color: "#0f172a",
          fontWeight: 800,
          lineHeight: 1.4,
          wordBreak: "break-word"
        }}
      >
        {value}
      </div>
    </div>
  )
}